import type { RouteRecordRaw, Router } from 'vue-router'

const SaleContractRoutes: RouteRecordRaw = {
  path: '/contract/estate/sale',
  name: 'EstateSaleModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'EstateSaleMainRoute',
      component: () => import('./views/SaleView.vue'),
      meta: {
        title: 'sale.saleContract',
      },
    },
    {
      path: 'create',
      name: 'EstateSaleCreateRoute',
      component: () => import('./views/SaleUpsertView.vue'),
      meta: {
        title: 'sale.createSaleContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:saleId',
      name: 'EstateSaleEditRoute',
      component: () => import('./views/SaleUpsertView.vue'),
      meta: {
        title: 'sale.editSaleContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:saleId',
      name: 'ViewEstateSaleRoute',
      component: () => import('./views/SingleSaleView.vue'),
      meta: {
        title: 'sale.ViewSale',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(SaleContractRoutes)
}
